const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  offset: 0,
  limit: 20,
  hasMoreItems: false,
  error: null,
  nbResult: 0
};
export const eboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_MAILS": {
      return { ...initialState };
    }
    case "FETCH_MAILS_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_MAILS_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case "FETCH_MAILS_REJECTED": {
      let error = action.payload;
      let help = [...state.items];
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          help = [];
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [...help],
        error
      };
    }
    case "FETCH_INFINITE_MAILS_PENDING": {
      return { ...state, fetched: false, fetching: true, hasMoreItems: true };
    }
    case "FETCH_INFINITE_MAILS_FULFILLED": {
      const { data = [], nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        hasMoreItems: data.length >= state.limit,
        offset: state.offset + state.limit,
        error: null,
        items: state.items.concat(data),
        nbResult: nbResult
      };
    }
    case "FETCH_INFINITE_MAILS_REJECTED": {
      let error = action.payload;

      if (error && error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        hasMoreItems: false,
        error
      };
    }

    default:
      return state;
  }
};

const initialGalleryState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0
};
export const galleryReducer = (state = initialGalleryState, action) => {
  switch (action.type) {
    case "RESET_GALLERY": {
      return { ...initialState };
    }
    case "FETCH_GALLERY_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_GALLERY_FULFILLED": {
      //const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload
        //nbResult: nbResult
      };
    }
    case "FETCH_GALLERY_REJECTED": {
      let error = action.payload;
      let help = [...state.items];
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          help = [];
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [...help],
        error
      };
    }

    default:
      return state;
  }
};

const initialClientState = {
  fetching: false,
  fetched: false,
  items: [],
  offset: 0,
  limit: 20,
  hasMoreItems: false,
  error: null,
  nbResult: 0
};
export const clientEboxReducer = (state = initialClientState, action) => {
  switch (action.type) {
    case "RESET_CLIENT_MAILS": {
      return { ...initialState };
    }
    case "FETCH_CLIENT_MAILS_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_CLIENT_MAILS_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case "FETCH_CLIENT_MAILS_REJECTED": {
      let error = action.payload;
      let help = [...state.items];
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          help = [];
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [...help],
        error
      };
    }
    case "FETCH_INFINITE_CLIENT_MAILS_PENDING": {
      return { ...state, fetched: false, fetching: true, hasMoreItems: true };
    }
    case "FETCH_INFINITE_CLIENT_MAILS_FULFILLED": {
      const { data = [], nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        hasMoreItems: data.length >= state.limit,
        offset: state.offset + state.limit,
        error: null,
        items: state.items.concat(data),
        nbResult: nbResult
      };
    }
    case "FETCH_INFINITE_CLIENT_MAILS_REJECTED": {
      let error = action.payload;

      if (error && error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        hasMoreItems: false,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ebox.js